export enum Dominio {
	FEDERAL = 'Federal',
	ESTADUAL = 'Estadual',
	MUNICIPAL = 'Municipal',
}
